import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Hero from "../containers/Hero";
import { auth } from "../services/auth";
import { useAuth } from "../services/AuthProvider";
import { Helmet } from "react-helmet";
import styles from "../css/logIn.module.css";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const { setAuth } = useAuth();
  const navigate = useNavigate();

  const handleLogin = async (event) => {
    event.preventDefault();
    if (!email || !password) {
      // TODO: Display error messages/labels
      return;
    }
    setIsLoading(true);
    const response = await auth().login({
      Email: email,
      Password: password,
    });

    if (response) {
      setAuth(true);
      setIsLoading(false);
      setHasError(false);
      navigate("/settings");
    } else {
      setAuth(false);
      setIsLoading(false);
      setHasError(true);
    }
  };

  return (
    <section>
      <Helmet>
        <title>Dailysocialboost | Log in</title>
      </Helmet>
      <Hero>
        <div className="container mx-auto px-24">
          <h2 className="text-5xl font-bold my-10">Log In</h2>
          <form onSubmit={handleLogin}>
            <div className="my-5">
              <label className="uppercase font-semibold" htmlFor="email">
                Email Address
              </label>
              <input
                className={`h-8 w-full ${styles.logInInput}`}
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                name="email"
                id="email"
                autoFocus
                required
              />
            </div>
            <div className="my-5">
              <label className="uppercase font-semibold" htmlFor="password">
                Password
              </label>
              <input
                className={`h-8 w-full ${styles.logInInput}`}
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                name="password"
                id="password"
                required
              />
            </div>
            {hasError ? <p className="text-red-600">There was an error logging in!</p> : null}
            <div className="flex flex-row justify-between items-center">
              <div>
                <button
                  className={`my-5 px-20 py-3 ${styles.logInBtn}`}
                  disabled={!email || !password || isLoading}
                  type="submit"
                  value="Log In"
                >
                  Log In
                </button>
              </div>
              <div>
                <Link className={`${styles.logInLink}`} to="/resetPassword">
                  Forgot Password?
                </Link>
              </div>
            </div>
          </form>
          <p>
            Don't have an account?{" "}
            <Link className={`${styles.logInLink}`} to="/signup">
              Sign Up
            </Link>
          </p>
        </div>
      </Hero>
    </section>
  );
}
